import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import HeroSection from './HeroSection';
import SubmissionForm from './SubmissionForm';
import VerdictGrid from './VerdictGrid';
import MysteryGiftBanner from './MysteryGiftBanner';
import './RealTalk.css';

export default function RealTalkPage() {
  useEffect(() => {
    document.title = 'Campus Truth — Real Students. Real Colleges. Real Experience. | CollegeUnlock';
    const meta = document.querySelector('meta[name="description"]') || (() => {
      const m = document.createElement('meta'); m.setAttribute('name', 'description'); document.head.appendChild(m); return m;
    })();
    meta.setAttribute('content', 'Campus Truth by CollegeUnlock: honest, verified student reviews of Indian colleges. Written & voice reviews. कॉलेज का असली सच जानें.');
    if (typeof window !== 'undefined' && window.gtag) {
      window.gtag('event', 'campus_truth_page_view', { page_path: '/campus-truth' });
    }
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="rt-page" data-testid="real-talk-page">
      <MysteryGiftBanner />
      <HeroSection />
      <SubmissionForm onSuccess={() => {}} />
      <VerdictGrid />
      <section className="rt-footer-cta">
        <div className="rt-footer-cta-inner">
          <h2>Your college experience matters.</h2>
          <p>Help the next batch make smarter decisions.</p>
          <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap', justifyContent: 'center' }}>
            <button
              onClick={() => {
                const form = document.getElementById('rt-submission-form');
                if (form) form.scrollIntoView({ behavior: 'smooth' });
              }}
              className="rt-hero-cta"
              data-testid="rt-footer-cta-btn"
            >
              Rate Your College →
            </button>
            <Link
              to="/ai-counseling"
              onClick={() => { if (typeof window !== 'undefined' && window.gtag) window.gtag('event', 'campus_truth_to_ai_fit_click', { location: 'campus_truth_footer' }); }}
              data-testid="ct-to-ai-fit-link"
              className="ct-banner-secondary"
              style={{ textDecoration: 'none' }}
            >
              Try Free AI Fit Check →
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
